import React from "react"
import contactStyles from "./contact.module.scss"

const Contact = () => {
  return (
    <div className={contactStyles.contact} id="contact">
      <h2>Kontakt</h2>
      <div className={contactStyles.contentWrapper}>
       {/*  <div className={contactStyles.card}>
          <h3></h3>
          <div className={contactStyles.card__textbox}>
          <img src={require("../img/cil_location-pin.svg")} alt="kontakt ikona"></img>
          <p></p>
          <img src={require("../img/cil_envelope-letter.svg")} alt="kontakt ikona"></img>
          <p></p>
          <img src={require("../img/cil_phone.svg")} alt="kontakt ikona"></img>
          <p></p>
          </div>
        </div> */}
        <form className={contactStyles.form}>
          <div className={contactStyles.form__item}>
            <label for="name">Imię i nazwisko</label>
            <input type="text" name="name" required></input>
          </div>
          <div className={contactStyles.form__item}>
            <label for="email">Adres email</label>
            <input type="email" name="email" required></input>
          </div>
          <div className={contactStyles.form__item}>
            <label for="message">Wiadomość</label>
            <textarea
              rows="7"
              cols="10"
              placeholder=""
              name="message"
              required
            ></textarea>
          </div>
          
          <input type="" name="submit" className="btn-callout" value="wyślij"/>
        </form>
      </div>
    </div>
  )
}

export default Contact
